import { getQueryClient } from '@cliengo/mfe-utils/mod';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import * as Sentry from '@sentry/react';

import { Main } from './Main';

import '@fontsource-variable/inter';

declare global {
  interface Window {
    cliengo_query_client: QueryClient;
  }
}

const client = getQueryClient();

window.cliengo_query_client = client;

function App() {
  return (
    <QueryClientProvider client={client}>
      <Main />
    </QueryClientProvider>
  );
}

export default Sentry.withProfiler(App);
